__turbopack_context__.v({
  "applicationLoader": "BlogConnectModalForm-module-scss-module__AJsbna__applicationLoader",
  "authorization": "BlogConnectModalForm-module-scss-module__AJsbna__authorization",
  "commonMargins": "BlogConnectModalForm-module-scss-module__AJsbna__commonMargins",
  "emailContainer": "BlogConnectModalForm-module-scss-module__AJsbna__emailContainer",
  "error": "BlogConnectModalForm-module-scss-module__AJsbna__error",
  "errorMessage": "BlogConnectModalForm-module-scss-module__AJsbna__errorMessage",
  "formHeading": "BlogConnectModalForm-module-scss-module__AJsbna__formHeading",
  "inputWrapper": "BlogConnectModalForm-module-scss-module__AJsbna__inputWrapper",
  "newLeadFormEmail": "BlogConnectModalForm-module-scss-module__AJsbna__newLeadFormEmail",
  "newLeadFormFirstName": "BlogConnectModalForm-module-scss-module__AJsbna__newLeadFormFirstName",
  "newLeadFormPhone": "BlogConnectModalForm-module-scss-module__AJsbna__newLeadFormPhone",
  "newLeadFormWrapper": "BlogConnectModalForm-module-scss-module__AJsbna__newLeadFormWrapper",
  "root": "BlogConnectModalForm-module-scss-module__AJsbna__root",
  "w25": "BlogConnectModalForm-module-scss-module__AJsbna__w25",
  "w75": "BlogConnectModalForm-module-scss-module__AJsbna__w75",
});
